// @flow

import moment from 'moment';
import { formatTimeWithPeriod, combinedDateAndTime } from 'clark-utils';

type TimeObjectType = {
  time: string,
  period: string,
};

const combineDateAndTimeObject = (date: moment, timeObject: TimeObjectType) => {
  const { time, period } = timeObject;
  const formatTime = formatTimeWithPeriod(time, period);
  const formattedTimeObject = moment(formatTime, 'h:mm a');

  return combinedDateAndTime(date, formattedTimeObject);
};

export default combineDateAndTimeObject;



// WEBPACK FOOTER //
// ./src/utils/helpers/combine-date-time.js